import { useGetUserSettingsQuery } from '../graphql/advisor/generates';
import { getGraphQLClient } from '../graphql/graphQLClient';

export const useGetQuickAccessSetting = (settingsFeatureFlag: boolean) =>
  useGetUserSettingsQuery(getGraphQLClient('advisor'), undefined, {
    select: (userSettings) =>
      userSettings.user.settings?.find((setting) => setting.code === 'QUICK_ACCESS_TOGGLE'),
    enabled: settingsFeatureFlag,
  });
